import { render } from "./CompletedWalksView.vue?vue&type=template&id=01b0a56c&scoped=true"
import script from "./CompletedWalksView.vue?vue&type=script&lang=js"
export * from "./CompletedWalksView.vue?vue&type=script&lang=js"

import "./CompletedWalksView.vue?vue&type=style&index=0&id=01b0a56c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b0a56c"]])

export default __exports__